import React, { useContext, useRef, useState } from "react";
import * as notify from "../../../shared/notify";

import { ButtonSelect } from "../../form-inputs/inputs";
import { useInput } from "../../../shared/hooks/form-fields";
import { createGroupShot } from "../lib/imageData";
import { PhotographyContext } from "../../../contexts/photography";
import { EDITING_SOURCE_MAP } from "../../photography/lib/helpers";

const AddShot = ({ sourcePage, ...props }) => {
    const [inProgress, setInProgress] = useState(false);
    const { lookups, convertToDropdownList } = useContext(PhotographyContext);
    const shotSelect = useInput("");
    const fileInput = useRef();

    const createGroupShotOnClick = () => {
        // Only proceed if the value is set
        if (shotSelect.value && !inProgress) {
            // Pretend the user is clicking the file to set off our events
            fileInput.current.click();
        }
    };

    const createGroupShotOnChange = async (e) => {
        const files = e.target.files;

        if (files.length > 0) {
            setInProgress(true);
            const formData = new FormData();
            formData.append("ImageView", shotSelect.value);
            formData.append("editingSourceId", EDITING_SOURCE_MAP["internal"]); // Set to Internal from here
            formData.append("AwaitThumbnailCreation", true);
            formData.append("File", files[0]);

            const shot = await createGroupShot(props.wipKey, props.taskKey, sourcePage, formData);

            if (shot) {
                props.addShot(shot);
                shotSelect.setValue("");
                notify.success("Uploaded Successfully!");
            }

            fileInput.current.value = "";
        }

        setInProgress(false);
    };

    const groupShots = convertToDropdownList(lookups.groupShots.filter((dd) => !props.usedShots.includes(dd.imageViewCode)));
    const shots = convertToDropdownList(lookups.imageViews.filter((dd) => !props.usedShots.includes(dd.imageViewCode)));
    const groupShotLabel = groupShots.length > 0 ? [{ label: "Group Shots", options: groupShots }] : [];
    const groups = [{ label: " -- Add a Shot --", value: "" }, ...groupShotLabel, { label: "Individual Shots", options: shots }];

    return (
        <div>
            <input
                type="file"
                ref={fileInput}
                name={`groupShotFile`}
                accept=".jpg,.jpeg,.png"
                hidden={true}
                onChange={createGroupShotOnChange}
                disabled={props.isReadOnly}
            />
            <ButtonSelect
                buttonClick={createGroupShotOnClick}
                groups={groups}
                {...shotSelect.bind}
                excludeSelect={true}
                disabled={props.isReadOnly}
            />
        </div>
    );
};

export default AddShot;
